import * as React from "react";
import { ReactComponent as Playhead } from "../pages/home/img/Playhead.svg"
import "./VideoSection.scss";
interface IVideoSectionProps {
    video: string;
    placeholder: string;
    showPlayhead?: boolean;
}

export const VideoSection: React.FunctionComponent<IVideoSectionProps> = (props) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = React.useState(false);

  function onPlay() {
    const video = videoRef.current;
    if (video) {
      video.play();
      setIsPlaying(true);
    }
  }

  function onPause() {
    const video = videoRef.current;
    if (video) {
      video.pause();
      setIsPlaying(false);
    }
  }

  function onStop() {
    const video = videoRef.current;
    if (video) {
      video.load();
      setIsPlaying(false);
    }
  }

  return (
    <div className="VideoSection">
      <video
        ref={videoRef}
        className="VideoSection__video"
        src={props.video}
        onPause={onPause}
        poster={props.placeholder}
        controls={isPlaying}
        onEnded={onStop}
      />
      {props.showPlayhead && !isPlaying && <Playhead onClick={onPlay} className="Playhead" />}
    </div>
  );
};